import React from 'react';
import { styled } from '@linaria/react';
import { Link } from '@daedalus/atlas/Link';
import { Text } from '@daedalus/atlas/Text';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
const AgreementWrapper = /*#__PURE__*/styled('div')({
  name: "AgreementWrapper",
  class: "a1mkn2kl",
  propsAsIs: false
});
export const Agreement = () => {
  const {
    brand
  } = useBrand();
  return <AgreementWrapper>
      <Text variant="bodyXS" colorPath="content.neutral.c600">
        <FormattedMessageWrapper id="magicLinkModal.agreementMessage" defaultMessage="By continuing, you agree with our <TermsOfUse></TermsOfUse> and <PrivacyPolicy></PrivacyPolicy>." values={{
        TermsOfUse: () => <Link href={brand?.links?.termsOfUseUrl} target="_blank" rel="noreferrer" variant="info">
                <FormattedMessageWrapper id="termsOfUse" defaultMessage="Terms of Use" />
              </Link>,
        PrivacyPolicy: () => <Link href={brand?.links?.privacyPolicyUrl} target="_blank" rel="noreferrer" variant="info">
                <FormattedMessageWrapper id="privacyPolicy" defaultMessage="Privacy Policy" />
              </Link>
      }} />
      </Text>
    </AgreementWrapper>;
};

require("./Agreement.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Agreement.tsx");